import * as React from "react";
import { HBox, VBox } from "framework/structural_components/hbox_vbox";
import { cls_colorCyan70, cls_cursor_pointer, cls_gap_half_rem, cls_p4b, cls_p5r, cls_p6r, cls_tableNumber, cls_text_align_center, cls_wrap } from "style/index.css";
import { cls_bottom_border, cls_col_1, cls_col_31, cls_col_32, cls_mark_box } from "./view.css";
import { replaceAll } from "framework/helpers";
import { cls_align_items_center, cls_align_items_flex_end, cls_justify_content_center } from "framework/structural_components/hbox_vbox.css";
import { useResponsivity } from "framework/responsivity/store";
import { useCompetitionResultState } from "../store";
import { Link } from "framework/link/link";
import { DanceLabels } from "./view";
import { UrlPathOfPublicSection } from "common/paths";
export var CompetitorRoundMarks = function (props) {
    var marks_dict = {};
    var danceResults_dict = {};
    var marks = props.competitorResultRound.marks.split('|');
    var danceResults = props.competitorResultRound.danceResults;
    var roundTypeIsFinalWithMarks = null;
    var dancesMarks = [];
    var idance = 0;
    var _loop_1 = function (i) {
        var val = marks.slice(i, i + props.numberOfAdjudicators).join('');
        val = replaceAll(val, 'X', '×');
        val = replaceAll(val, '-', '−');
        dancesMarks.push(val);
        marks_dict[props.roundWithCompetitors.dances[idance]] = val;
        danceResults_dict[props.roundWithCompetitors.dances[idance]] = danceResults[idance].toString();
        idance++;
        if (roundTypeIsFinalWithMarks === null) {
            [1, 2, 3, 4, 5, 6, 7, 8, 9].forEach(function (num) {
                if (val.includes(num.toString())) {
                    roundTypeIsFinalWithMarks = true;
                }
            });
            if (roundTypeIsFinalWithMarks === null) {
                roundTypeIsFinalWithMarks = false;
            }
        }
    };
    for (var i = 0; i < marks.length; i += props.numberOfAdjudicators) {
        _loop_1(i);
    }
    return React.createElement(React.Fragment, null, props.dances.map(function (d, iDance) { return React.createElement(VBox, { key: iDance, className: cls_col_31 },
        props.showDanceNames && React.createElement(HBox, { className: [cls_justify_content_center, cls_col_31, cls_text_align_center] }, d),
        React.createElement(HBox, { className: [cls_justify_content_center, cls_col_31, cls_tableNumber, cls_p6r] }, d in marks_dict ? marks_dict[d].split('').map(function (m, mi) { return React.createElement(HBox, { key: mi, className: [cls_mark_box, cls_justify_content_center] }, m); }) : ''),
        React.createElement(HBox, { className: [cls_justify_content_center, cls_col_31, cls_tableNumber] }, d in danceResults_dict && roundTypeIsFinalWithMarks ? danceResults_dict[d] : '')); }));
};
var CompetitorDetailRound = function (props) {
    var crr = props.competitorResultRound;
    return React.createElement(React.Fragment, null,
        React.createElement(VBox, { className: [cls_colorCyan70, cls_col_32] },
            React.createElement(HBox, null,
                React.createElement(Link, { className: cls_cursor_pointer, url: "".concat(UrlPathOfPublicSection, "/vysledky_soutezi/event/").concat(props.eventId, "/competition/").concat(props.compId, "/round/").concat(props.roundWithCompetitors.number) }, props.competitorResultRound.round))),
        React.createElement(HBox, { className: [cls_col_1, cls_justify_content_center] },
            crr.ranking == crr.rankingTo ? crr.ranking : crr.ranking + ".–" + crr.rankingTo,
            "."),
        React.createElement(HBox, { className: [cls_wrap, cls_gap_half_rem, cls_align_items_flex_end] },
            React.createElement(CompetitorRoundMarks, { competitorResultRound: props.competitorResultRound, roundWithCompetitors: props.roundWithCompetitors, numberOfAdjudicators: props.numberOfAdjudicators, dances: props.dances, showDanceNames: props.showDanceNames })));
};
var CompetitorDetailRoundDances = function (props) {
    return React.createElement(HBox, { className: [cls_bottom_border, cls_gap_half_rem] },
        React.createElement(HBox, { className: cls_col_32 }),
        React.createElement(HBox, { className: cls_col_1 }),
        React.createElement(HBox, { className: [cls_wrap, cls_gap_half_rem] },
            React.createElement(DanceLabels, { dances: props.dances })));
};
export var CompetitorDetail = function (props) {
    var _a;
    var comp_result_state = useCompetitionResultState()[0];
    var state_resp = useResponsivity()[0];
    var T_HFM = state_resp.thresholdHeaderForMobile;
    var cr = props.competitorResult;
    var c = props.competitorResult.competitor;
    var roundDances = props.roundsWithCompetitors.map(function (r) { return r.dances; });
    var dancesDoNotDifferBetweenRounds = roundDances.every(function (rd) { return JSON.stringify(rd) === JSON.stringify(roundDances[0]); });
    return React.createElement(React.Fragment, null,
        React.createElement(HBox, { className: [cls_wrap, cls_gap_half_rem, cls_align_items_center] },
            React.createElement(HBox, { className: [cls_p4b, cls_colorCyan70] },
                c.surname1,
                " ",
                c.name1,
                c.surname2 && c.name2 ? React.createElement(React.Fragment, null,
                    " & ",
                    c.surname2,
                    " ",
                    c.name2) : null,
                " "),
            React.createElement(HBox, { className: [cls_p5r] }, (_a = props.competitorResult.club) !== null && _a !== void 0 ? _a : "",
                !T_HFM && c.country != "CZE" && React.createElement(React.Fragment, null,
                    " (",
                    c.country,
                    ")"))),
        React.createElement(VBox, { className: cls_p5r },
            dancesDoNotDifferBetweenRounds && React.createElement(CompetitorDetailRoundDances, { dances: props.dances }),
            comp_result_state.roundsWithCompetitors.filter(function (r) { return true; }).reverse().map(function (r, ir) { return React.createElement(VBox, { key: ir }, cr.rounds.filter(function (rr) { return rr.round == r.round; }).map(function (scr, iscr) {
                var dances = dancesDoNotDifferBetweenRounds ? props.dances : r.dances;
                return React.createElement(VBox, { key: ir, className: cls_gap_half_rem },
                    React.createElement(HBox, { key: iscr, className: [cls_bottom_border, cls_gap_half_rem] },
                        React.createElement(CompetitorDetailRound, { competitorResult: props.competitorResult, competitorResultRound: scr, roundWithCompetitors: props.roundsWithCompetitors.filter(function (rwc) { return rwc.round == r.round; })[0], numberOfAdjudicators: props.numberOfAdjudicators, compId: props.compId, dances: dances, eventId: props.eventId, showDanceNames: dancesDoNotDifferBetweenRounds === false })));
            })); })));
};
